import { Button } from "../../components/UI/Button"
import React from 'react'
import { InnerTile, Tile } from './style'
function PortfolioTile({ image, openPreviewFunc, previewLink }) {

    return (
        <>
            <Tile>
                <InnerTile>
                    <div className='box-front'>
                        <img src={image} />
                    </div>
                    <div className='box-back'>
                        <div>
                            <p className="tileInfo tileName">McMakler</p>
                            <p className="tileInfo tile-link">https://link.link.com</p>
                            <span className="skillsUsed">
                                React, Styled Components, Framer Motion, Typescript, Tag Canvas, SCSS.
                            </span>

                            <div className='buttons'>
                                <button onClick={() => openPreviewFunc(true, previewLink)}>Preview</button>
                                <button>
                                    <a href={previewLink} target="__blank">Visit Site</a>
                                </button>
                            </div>
                        </div>
                    </div>
                </InnerTile>
            </Tile>
        </>

    )
}

export default PortfolioTile